import FallbackImage from './FallbackImage.vue'

export { FallbackImage }
export default FallbackImage
